import Progress from '../../Survey/Progress';
import { COLORS } from '../../../config/designSystem/Colors';
import { FC } from 'react';
import { View } from 'react-native-animatable';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStores } from '../../../hooks/useStores';

interface ContentProgressBar {
  margin?: number;
}
const ContentProgressBar: FC<ContentProgressBar> = ({
  margin = 0,
}) => {
  const { treeNav } = useStores();
  const { width } = useAvailableDimensions();
  const insets = useSafeAreaInsets();
  const height = 2 + insets.bottom / 4;
  return (
    <View style={{ marginBottom: margin, width }}>
      <Progress
        color={COLORS.surface.secondary}
        secondaryColor={COLORS.surface['inverse-primary']}
        step={treeNav.stepNumber}
        steps={treeNav.maxSteps}
        height={height}
      />
    </View>
  );
};
export default observer(ContentProgressBar);
